import {
    DownloadAppSection,
    EmployerCtaSection,
    EnergyMarketplaceCategories,
    FeaturedCompanies,
    LandingHero,
    LatestJobOpportunities,
    MarketplaceSearch,
    PartnerSponsorship,
} from "../../components/Public";

export default function LandingPage() {
    return <>
        <LandingHero/>
        <MarketplaceSearch/>
        <EnergyMarketplaceCategories/>
        <FeaturedCompanies/>
        <LatestJobOpportunities/>
        <EmployerCtaSection/>
        <PartnerSponsorship/>
        <DownloadAppSection/>
    </>
}
